import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainApi } from "../../api/axios";

/**
 * Fetch dine areas
 */
export const getDineAreas = createAsyncThunk(
  "dine/getDineAreas",
  async ({ storeId }, { rejectWithValue }) => {
    try {
      const res = await mainApi.get(`/v1/pos/dine?store_id=${storeId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

/**
 * Add dine area
 */
export const addDine = createAsyncThunk(
  "dine/addDine",
  async (obj, { rejectWithValue }) => {
    try {
      const res = await mainApi.post("/v1/pos/dine", obj);
      return res.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

/**
 * Update dine area
 */
export const updateDine = createAsyncThunk(
  "dine/updateDine",
  async (obj, { rejectWithValue }) => {
    try {
      const res = await mainApi.patch("/v1/pos/dine", obj);
      return res.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

/**
 * Delete dine area
 */
export const dineDelete = createAsyncThunk(
  "dine/dineDelete",
  async (obj, { rejectWithValue }) => {
    try {
      const res = await mainApi.patch("/v1/pos/dine/actions", obj);
      const dataObj = {
        ...res.data,
        ...obj,
      };
      return dataObj; // return deleted payload to update state
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

/**
 * Perform dine action
 */
export const dineAction = createAsyncThunk(
  "dine/dineAction",
  async (obj, { rejectWithValue }) => {
    try {
      const res = await mainApi.patch("/v1/pos/dine/actions", obj);
      const dataObj = {
        ...res.data,
        ...obj,
      };
      return dataObj; // return updated dine action info
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Slice
const dineSlice = createSlice({
  name: "dine",
  initialState: {
    areas: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearDineState: (state) => {
      state.areas = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET
      .addCase(getDineAreas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDineAreas.fulfilled, (state, action) => {
        state.loading = false;
        state.areas = action.payload;
      })
      .addCase(getDineAreas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ADD
      .addCase(addDine.pending, (state) => {
        state.loading = true;
      })
      .addCase(addDine.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addDine.rejected, (state, action) => {
        state.loading = false;
      })

      // UPDATE
      .addCase(updateDine.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDine.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateDine.rejected, (state, action) => {
        state.loading = false;
      })

      // DELETE
      .addCase(dineDelete.fulfilled, (state, action) => {
        const deleted = action.payload;
        state.areas = state.areas.filter((a) => a.id !== deleted.id);
      })

      // ACTION (e.g. activate/deactivate)
      .addCase(dineAction.fulfilled, (state, action) => {
        const updated = action.payload;
        state.areas = state.areas.map((a) =>
          a.id === updated.id ? { ...a, ...updated } : a
        );
      });
  },
});

export const { clearDineState } = dineSlice.actions;
export default dineSlice.reducer;
